/** Shared style constants for pick path rendering */
export const PICK_PATH_OUTLINE_WIDTH = 2;
export const PICK_PATH_ARROW_SIZE = 4.0;
export const PICK_PATH_Z_INDEX = 200000;
export const PICK_PATH_DEFAULT_COLOR = '#FF0000';
